import RequestBase from "./RequestBase.ts";

export default class InGameRoles extends RequestBase {
    constructor(){
        super("InGameRoles/");
    }
}
